<template>
  <div class="exam-profiles width-responsiveness--centralized">
    <div class="exam-profiles__container">
      <subheader
        title="Perfis de exames"
        :centralized="false"
        :back-button-visible="true"
        :path="'/dashboard'"
      >
        <div class="search-box-container">
          <input
            id="searcExamProfileInput"
            v-model="filterInput"
            class="search-box__input"
            placeholder="Pesquisar..."
          >
          <img
            class="search-box__icon"
            src="/static/images/icon-search-purple.svg"
          >
        </div>
        <button
          id="btnCreateExamProfile"
          class="btn btn-primary btn-regular-size"
          @click="$router.push('exam-profiles/new')"
        >
          <img src="/static/images/icon-plus.svg">
          Novo perfil de exames
        </button>
      </subheader>

      <div class="exam-profiles__container">
        <exams-profile-list :filter-input="filterInput" />
      </div>
    </div>
    <page-scroll-top />
  </div>
</template>

<script>
import ExamProfilesList from './ExamProfilesList'
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'

export default {
  name: 'ExamProfiles',
  components: {
    subheader: SubHeader,
    'exams-profile-list': ExamProfilesList,
    'page-scroll-top': PageScrollTop
  },
  data: () => {
    return {
      filterInput: ''
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/mixins";

.exam-profiles {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 150px;

  .btn-primary {
    height: 38px;
    border-radius: 3px;
    padding: 0 18px;
    letter-spacing: 0.8px;
    font-family: Roboto;
    font-weight: 500;
  }

  &__container {
    width: 100%;
  }

  button {
    svg {
      height: 0.6em;
    }
  }

  .subheader__content__right-side {
    display: flex;
    align-items: center;

    .search-box {
      &-container {
        display: flex;
        background-color: white;
        border-radius: 3px;
        padding: 0.5em 0.3em 0.5em 1em;
        margin-right: 1em;
      }

      &__input {
        background-color: white;
        border: 0;
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        color: #4a4a4a;
        min-width: 187px;
        min-height: 19px;

        &::placeholder {
          color: #7a7a7a;
        }

        &:focus {
          border: 0;
          outline: none;
        }
      }

      &__icon {
        svg {
          width: 0.7em;
          height: 0.7em;

          path {
            fill: #7f1a54;
          }
        }
      }
    }
  }
  .subheader_container {
    button {
      img {
        position: relative;
        top: -1px;
      }
    }
  }
}
</style>
